import * as meta from '@/api/meta'

const state = {
  usuario: null,
  mensal: {
    relativa: 0,
    producao: 0,
    percentual: 0
  },
  diaria: {
    relativa: 0,
    producao: 0,
    percentual: 0
  },
  ranking: null,
  relatorio: {
    labels: [],
    meta: [],
    producao: [],
    maximo: 0
  }
}

const mutations = {
  SETUSUARIO (state, data) {
    state.usuario = data
  },
  SETMENSAL (state, data) {
    state.mensal.relativa = data.metaRelativa
    state.mensal.producao = data.producao
    state.mensal.percentual = data.percentual
  },
  SETDIARIA (state, data) {
    state.diaria.relativa = data.meta
    state.diaria.producao = data.producao
    state.diaria.percentual = data.percentual
  },
  SETRANKING (state, data) {
    if (data && data.ranking) state.ranking = data.ranking
    else state.ranking = null
  },
  SETRELATORIO (state, data) {
    let relatorio = { labels: [], meta: [], producao: [], maximo: 0 }
    // Labels
    relatorio.labels = []
    relatorio.labels = data.metas.map(e => e.dia)
    // List Meta
    relatorio.meta = data.metas.map(e => e.valor)
    // Lista Producao
    relatorio.producao = data.producoes.map(e => e.valor)
    // Valor Maximo
    // Meta
    let lgt = relatorio.meta.length
    if (lgt > 0) relatorio.maximo = relatorio.meta[lgt - 1]
    // Producao
    lgt = relatorio.producao.length
    if (lgt > 0) relatorio.maximo = relatorio.producao[lgt - 1] > relatorio.maximo ? relatorio.producao[lgt - 1] : relatorio.maximo
    // Set
    state.relatorio = relatorio
  }
}

const actions = {
  async changeUsuario ({ commit }, usuario) {
    commit('SETUSUARIO', usuario)
  },
  async atualiza ({ dispatch }) {
    await dispatch('producaoMensal')
    await dispatch('producaoDiaria')
    await dispatch('rankingUsuario')
    await dispatch('relatorioMensal')
  },
  async producaoMensal ({ state, commit }, payload) {
    let param = {}
    if (state.usuario) param.usuario_id = state.usuario
    if (payload) {
      if (payload.periodo) param.data_inicial = payload.periodo
    }
    commit('SETMENSAL', await meta.producaoMensal(param))
  },
  async producaoDiaria ({ state, commit }) {
    let param = {}
    if (state.usuario) param.usuario_id = state.usuario
    commit('SETDIARIA', await meta.producaoDiaria(param))
  },
  async rankingUsuario ({ state, commit }, payload) {
    let param = {}
    if (state.usuario) param.usuario_id = state.usuario
    if (payload) {
      if (payload.periodo) param.data_inicial = payload.periodo
    }
    commit('SETRANKING', await meta.rankingUsuario(param))
  },
  async relatorioMensal ({ state, commit }, payload) {
    let param = {}
    if (state.usuario) param.usuario_id = state.usuario
    if (payload) {
      if (payload.periodo) param.data_inicial = payload.periodo
    }
    commit('SETRELATORIO', await meta.relatorioMensal(param))
  }
}

export default { namespaced: true, state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/meta.js